import React from "react";
import Radium from "radium";
import moment from "moment-timezone";
import get from "lodash/get";
import merge from "lodash/merge";
import InjectedTenantHTML from "../injected-tenant-html.jsx";
import {
  CircularProgress,
  TextField,
  Table,
  TableBody,
  TableRow,
  TableRowColumn,
  Avatar,
  IconMenu,
  MenuItem,
  ListItem,
  RaisedButton,
  FlatButton,
  FontIcon,
  Dialog
} from "material-ui";
import { PopoverAnimationVertical } from "material-ui/Popover";
import TicketActions from "../../../actions/TicketActions";
import TicketStore from "../../../stores/TicketStore";
import BallotingRecord from "../balloting-record.jsx";
import AppUtil from "../../../utils/AppUtil.js";

const TransferOrCancelDialogButtonWrapper = Radium(({ children }) => {
  const styles = {
    float: "right",
    "@media (max-width: 650px)": {
      float: "none",
      marginBottom: 5
    }
  }

  return (
    <div style={styles}>{children}</div>
  )
})

class TicketListItem extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      cancelingTicket: null,
      selectedToTransfer: [],
      promptForTransferEmail: false,
      transferInProgress: false,
      transferEmail: "",
      showBallotModal: false
    };

    this._makeMenu = this._makeMenu.bind(this);
    this._makeAvatar = this._makeAvatar.bind(this);
    this._makeRightIcon = this._makeRightIcon.bind(this);

    this.transitionToEvent = this.transitionToEvent.bind(this);
    this.transitionToScan = this.transitionToScan.bind(this);
    this.downloadPdf = this.downloadPdf.bind(this);

    this.cancelTickets = this.cancelTickets.bind(this);
    this.transferTickets = this.transferTickets.bind(this);

    this._handleTransferTickets = this._handleTransferTickets.bind(this);

    this._handleCloseModal = this._handleCloseModal.bind(this);
  }

  static get contextTypes() {
    return {
      isLarge: React.PropTypes.bool,
      router: React.PropTypes.object.isRequired,
      tenant: React.PropTypes.object,
      appSettings: React.PropTypes.object,
      portalClassName: React.PropTypes.string
    };
  }

  getStyles() {
    return {
      iconButton: {
        height: "100%",
        display: "inline-block",
        verticalAlign: -1,
        lineHeight: "36px",
        fontSize: 15
      },
      rightIcon: {
        //position: "absolute",
        //top: "inherit",
        //right: "inherit",
        //bottom: 12,
        //left: 0,
        display: "inline-block"
      },
      rightIconLarge: {
        padding: 12,
        paddingLeft: 0,
      },
      qrCodeIcon: {
        marginLeft: -8,
        color: this.context.tenant.invert_colors ? "#000" : "#fff",
        paddingRight: 16
      },
      menu: {
        maxWidth: "90vw",
        textAlign: "left"
      },
      menuItem: {
        cursor: "pointer"
      },
      listItem: {
        paddingBottom: 56,
        display: "inline-block"
      },
      listItemLarge: {
        // noop
      },
      cancelTicketsItem: {
        border: "1px solid #ccc",
        margin: "10px 0",
        padding: 10,
        minHeight: 40
      },
      cancelTicketsError: {
        color: "#FF4136"
      },
      cancelTicketsSub: {
        fontStyle: "italic"
      },
      dialogTitle: {
        borderBottom: "none"
      },
      dialogActionsContainer: {
        borderTop: "none"
      }
    };
  }

  transitionToEvent() {
    this.context.router.push(`/schedule/${this.props.item.event.id}`);
  }

  transitionToScan() {
    this.context.router.push({
      pathname: `/tickets/${this.props.item.event.id}`,
      state: { fromTicketButton: true }
    });
  }

  downloadPdf() {
    TicketActions.downloadPdf(this.props.item.event.id);
  }

  cancelTickets() {
    this.context.router.push({
      pathname: "/tickets",
      query: { cancel: this.props.item.event.id }
    });
  }

  transferTickets() {
    this.context.router.push({
      pathname: "/tickets",
      query: { transfer: this.props.item.event.id }
    });
  }

  _handleCancelTicket(id) {
    this.setState({ cancelingTicket: id });
    TicketActions.deleteTicket(id);
  }

  _handleTransferTickets() {
    if (this.state.promptForTransferEmail) {
      this.setState({ transferInProgress: true });
      TicketActions.transferTickets(
        this.state.selectedToTransfer,
        this.state.transferEmail
      );
    } else {
      this.setState({
        promptForTransferEmail: true
      });
    }
  }

  _handleCancelTransfer(id) {
    TicketActions.cancelTicketTransfer(id);
  }

  _handleResendTransfer(id) {
    TicketActions.resendTicketTransfer(id);
  }

  _handleCloseModal() {
    this.context.router.push({
      pathname: "/tickets"
    });
    this.setState({ selectedToTransfer: [] });
  }

  _makeMenu(
    iconButtonElement,
    { isCompactMultiRowButtons, standalone, additionalItems }
  ) {
    let styles = this.getStyles();

    return (
      <IconMenu
        iconButtonElement={iconButtonElement}
        menuStyle={styles.menu}
        desktop={this.context.isLarge}
        animation={standalone ? PopoverAnimationVertical : undefined}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        targetOrigin={{ vertical: "top", horizontal: "right" }}
        style={isCompactMultiRowButtons ? { display: "block" } : {}}
      >
        {!this.props.item.event.is_virtual && !standalone ? (
          <MenuItem
            style={styles.menuItem}
            key="event"
            onClick={this.transitionToEvent}
            primaryText="View event details"
          />
        ) : null}
        {!this.props.item.event.is_virtual ? (
          <MenuItem
            style={styles.menuItem}
            key="pdf"
            onClick={this.downloadPdf}
            primaryText="Download printable tickets PDF"
          />
        ) : null}
        {moment().isBefore(moment(this.props.item.event.end_time)) && <MenuItem
          style={styles.menuItem}
          key="transfer"
          onClick={this.transferTickets}
          primaryText="Transfer tickets..."
        />}
        <MenuItem
          style={styles.menuItem}
          key="cancel"
          onClick={this.cancelTickets}
          primaryText="Cancel tickets..."
        />
        {additionalItems}
      </IconMenu>
    );
  }

  _makeAvatar() {
    return (
      <Avatar
        src={this.props.item ? this.props.item.event.images.avatar : null}
      />
    );
  }

  _makeRightIcon({ isCompactMultiRowButtons, standalone }) {
    let styles = this.getStyles(),
      { event, tickets } = this.props.item,
      { isLarge } = this.context,
      {
        online_balloting_for_physical_events_enabled,
        online_balloting_voting_enabled
      } = this.context.appSettings;

    let hasHideVoteTag = this.context.tenant.virtual_festival_hide_vote_button_tag ? event.tags.some(tag => tag.id === this.context.tenant.virtual_festival_hide_vote_button_tag) : false;
    let showVote =
      online_balloting_for_physical_events_enabled && !event.is_virtual && event.has_films && !hasHideVoteTag;
    let voteDisabled = tickets.every(t => t.ballot_recorded_at);
    let voteClosed = online_balloting_voting_enabled ? false : true;

    let buttonEventMode;
    if (event.is_virtual) {
      buttonEventMode = "virtual";
    } else {
      buttonEventMode = "physical";
    }

    return (
      <div
        style={
          standalone ? {} : isLarge ? styles.rightIconLarge : Object.assign(styles.rightIcon, { width: 200, paddingLeft: isLarge ? 16 : 0 })
        }
        className="eventive__ticket-list-item__button-container eventive__universal_ticket-button__container"
        data-button-mode={buttonEventMode}
      >
        {!standalone && showVote ? (
          <RaisedButton
            label={
              voteDisabled
                ? "Already voted"
                : voteClosed
                ? "Voting closed"
                : "Vote"
            }
            primary={true}
            labelPosition="before"
            onClick={() => {
              this.setState({ showBallotModal: !this.state.showBallotModal });
            }}
            disabled={voteDisabled || voteClosed}
            target="_blank"
            style={{ margin: "0px 12px 10px 0px" }}
          />
        ) : null}
        {this.props.hideScanTickets ? null : event.is_virtual ? (
          (() => {
            const virtualEvent = event;
            const isInAvailabilityWindow =
              !virtualEvent.start_time ||
              (Date.now() >= new Date(virtualEvent.start_time) &&
                Date.now() < new Date(virtualEvent.end_time));
            const isPastAvailabilityWindow =
              virtualEvent.end_time &&
              Date.now() > new Date(virtualEvent.start_time) &&
              Date.now() > new Date(virtualEvent.end_time);
            const isPastWatchWindow =
              virtualEvent.end_time &&
              virtualEvent.virtual_intervals &&
              virtualEvent.virtual_intervals.watch_interval &&
              Date.now() > new Date(virtualEvent.start_time) &&
              Date.now() > new Date(virtualEvent.end_time).getTime() + virtualEvent.virtual_intervals.watch_interval;
            const isInFuture =
              virtualEvent.start_time &&
              !isInAvailabilityWindow &&
              Date.now() < new Date(virtualEvent.start_time);
            const isExpired = tickets.every(
              t => Date.now() > new Date(t.expires_at || t.unlocked_until)
            );

            let label = "Watch now",
              disabled = false;

            if (isInFuture) {
              label = "Pre-ordered successfully";
              disabled = true;
            } else if (isPastAvailabilityWindow) {
              if (!isPastWatchWindow) {
                label = "Watch now";
              } else {
                label = "Already occurred";
                disabled = true;
              }
            } else if (isExpired) {
              label = "Expired";
              disabled = true;
            }

            // If not in universal ticket button, still always leave it clickable
            // to jump the user to the watch site.
            if (!this.props.onWatchNow) {
              disabled = false;
            }

            // Don't show the Virtual Catalog button in Sundance Mobile Mode
            if (AppUtil.isSundanceMobileMode(this.context.tenant)) {
              return null;
            }

            return (
              <RaisedButton
                label={label}
                disabled={disabled}
                primary={true}
                labelPosition="before"
                href={
                  this.props.onWatchNow
                    ? undefined
                    : `https://watch.eventive.org/${
                        tickets.length && tickets[0].tenant_slug
                      }/play/${event.id}`
                }
                onClick={
                  this.props.onWatchNow ? this.props.onWatchNow : undefined
                }
                target="_blank"
                style={{
                  verticalAlign: this.props.onWatchNow ? undefined : 2,
                  marginRight: 12
                }}
                className="eventive__universal_ticket-button__button"
              />
            );
          })()
        ) : !this.props.isPast ? (
          <RaisedButton
            label={
              this.props.sundanceMode
                ? tickets.length > 1
                  ? "Scan tickets"
                  : "Scan ticket"
                : `Show ${tickets.length} QR code${
                    tickets.length !== 1 ? "s" : ""
                  }`
            }
            primary={true}
            labelPosition="before"
            onClick={this.transitionToScan}
            style={{ marginRight: isCompactMultiRowButtons ? 0 : 12 }}
            className="eventive__universal_ticket-button__button"
          >
            <FontIcon
              className="icon-qrcode"
              style={merge({}, styles.iconButton, styles.qrCodeIcon)}
            />
          </RaisedButton>
        ) : null}
        {this.props.hideActions
          ? null
          : this._makeMenu(
              this.props.sundanceMode && isLarge ? (
                <FlatButton
                  label={
                    <span
                      style={{
                        display: "inline-block",
                        // transform: "translateY(-1px)",
                        margin: "0 -12px"
                      }}
                    >
                      <svg
                        width="28"
                        height="6"
                        viewBox="0 0 28 6"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <circle cx="3" cy="3" r="3" fill="black" />
                        <circle cx="14" cy="3" r="3" fill="black" />
                        <circle cx="25" cy="3" r="3" fill="black" />
                      </svg>
                    </span>
                  }
                />
              ) : (
                <FlatButton
                  style={
                    standalone
                      ? {
                          clear: "both",
                          border: "1px solid",
                          lineHeight: "38px"
                        }
                      : isLarge
                      ? {
                          clear: "both",
                          border: "1px solid",
                          lineHeight: "33px"
                        }
                      : {
                          marginTop: 10,
                          border: "1px solid",
                          lineHeight: "33px"
                        }
                  }
                  label={
                    <span style={{ verticalAlign: 3 }}>
                      <span
                        className="icon-cog"
                        style={
                          standalone
                            ? { verticalAlign: -2 }
                            : { verticalAlign: -1, marginRight: 5 }
                        }
                      ></span>
                      {standalone ? null : "Manage"}
                    </span>
                  }
                />
              ),
              {
                isCompactMultiRowButtons,
                standalone,
                additionalItems: standalone
                  ? []
                      .concat(
                        showVote && !this.props.sundanceMode
                          ? [
                              <MenuItem
                                style={styles.menuItem}
                                key="vote"
                                onClick={() => {
                                  this.setState({
                                    showBallotModal: !this.state.showBallotModal
                                  });
                                }}
                                primaryText={
                                  voteDisabled
                                    ? "Vote: Your vote has successfully been recorded."
                                    : "Vote for awards..."
                                }
                                disabled={voteDisabled}
                              />
                            ]
                          : []
                      )
                      .concat(
                        this.props.customActions
                          ? this.props.customActions.map(action => {
                              return (
                                <MenuItem
                                  style={styles.menuItem}
                                  key={action.label}
                                  primaryText={action.label}
                                  onClick={action.onClick}
                                  disabled={action.disabled}
                                />
                              );
                            })
                          : []
                      )
                  : undefined
              }
            )}
        {this.state.showBallotModal ? (
          <BallotingRecord
            eventId={event.id}
            tickets={tickets.map(t => {
              return t.id;
            })}
            onClose={() => {
              this.setState({ showBallotModal: false });
            }}
          />
        ) : null}
      </div>
    );
  }

  componentWillReceiveProps() {
    if (
      this.state.transferInProgress &&
      !TicketStore.getState().isTransferring
    ) {
      this.setState({
        transferInProgress: false,
        promptForTransferEmail: false,
        selectedToTransfer: []
      });
    }
  }

  render() {
    var { event, tickets } = this.props.item,
      {
        online_balloting_for_physical_events_enabled
      } = this.context.appSettings,
      styles = this.getStyles(),
      timeRange = moment(event.start_time)
        .twix(event.end_time)
        .format({ showDate: this.props.showExtended, groupMeridiems: false }),
      { isLarge } = this.context;

    const ticketBucketMap = new Map();

    tickets.map(ticket => ticket.ticket_bucket.name).forEach(ticket => {
      if (ticketBucketMap.has(ticket)) {
        let number = ticketBucketMap.get(ticket)
        ticketBucketMap.set(ticket, number + 1)
      } else {
        ticketBucketMap.set(ticket, 1)
      }
    });

    const ticketBucketAmounts = []

    for (const ticketBucket of ticketBucketMap.entries()) {
      ticketBucketAmounts.push({
        name: ticketBucket[0],
        amount: ticketBucket[1]
      })
    }

    let isCompactMultiRowButtons =
      !isLarge;

    let passesUsed = tickets.filter(t => t.pass).map(t => t.pass.name),
      cancellableTickets = tickets.filter(t => t.probably_customer_cancellable),
      transferableTickets = tickets.filter(
        t => t.probably_customer_transferable && !t.pending_transfer
      ),
      pendingTransfers = tickets.reduce((o, t) => {
        if (t.pending_transfer) {
          o[t.pending_transfer.id] = (o[t.pending_transfer.id] || []).concat([
            t
          ]);
        }
        return o;
      }, {}),
      numberOfPendingTransfers = Object.keys(pendingTransfers).length;

    let showVote =
      online_balloting_for_physical_events_enabled && !event.is_virtual;

    const hasLongVenue = event && event.venue && event.venue.name && event.venue.name.length > 65;

    return (
      <div>
        <Dialog
          titleStyle={styles.dialogTitle}
          actionsContainerStyle={styles.dialogActionsContainer}
          title={`Cancel tickets to "${event.name}"`}
          className={`Eventive--Dialog ${this.context.portalClassName}`}
          open={this.context.router.isActive({
            pathname: "/tickets",
            query: { cancel: event.id || "no-event" }
          })}
          actions={[
            <FlatButton
              style={styles.dialogButton}
              label="Close"
              onClick={this._handleCloseModal}
            />
          ]}
          autoScrollBodyContent={true}
          onRequestClose={this._handleCloseModal}
        >
          <InjectedTenantHTML
            content={
              this.context.tenant.physical_ticket_cancellation_dialog_message
            }
          />
          {cancellableTickets.length === 0 ? (
            <p>
              You currently have no tickets to this event eligible for automatic
              cancellation.
            </p>
          ) : (
            <div>
              {cancellableTickets.map(t => {
                return (
                  <div style={styles.cancelTicketsItem} key={t.id}>
                    <TransferOrCancelDialogButtonWrapper>
                      <RaisedButton
                        style={styles.dialogButton}
                        label="Cancel ticket"
                        onClick={() => this._handleCancelTicket(t.id)}
                      />
                    </TransferOrCancelDialogButtonWrapper>
                    <div>
                      {t.pass.name} &ndash; {event.name} ({t.ticket_bucket.name}
                      )
                    </div>
                    {t.deleteError ? (
                      <div style={styles.cancelTicketsError}>
                        Error canceling ticket: {t.deleteError}
                      </div>
                    ) : (
                      <div style={styles.cancelTicketsSub}>
                        This ticket may be eligible for cancellation.
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          )}
        </Dialog>

        <Dialog
          titleStyle={styles.dialogTitle}
          actionsContainerStyle={styles.dialogActionsContainer}
          title={`Transfer tickets to "${event.name}"`}
          className={`Eventive--Dialog ${this.context.portalClassName}`}
          open={this.context.router.isActive({
            pathname: "/tickets",
            query: { transfer: event.id || "no-event" }
          })}
          actions={[
            <FlatButton
              style={styles.dialogButton}
              label={this.state.promptForTransferEmail ? `Back` : `Close`}
              onClick={() =>
                this.state.promptForTransferEmail
                  ? this.setState({ promptForTransferEmail: false })
                  : this._handleCloseModal()
              }
            />,
            <FlatButton
              style={styles.dialogButton}
              disabled={
                this.state.selectedToTransfer.length === 0 ||
                (this.state.promptForTransferEmail && !this.state.transferEmail)
              }
              primary={true}
              label={
                this.state.promptForTransferEmail
                  ? `Confirm & send transfer`
                  : `Transfer ${this.state.selectedToTransfer.length} ticket${
                      this.state.selectedToTransfer.length === 1 ? "" : "s"
                    }...`
              }
              onClick={this._handleTransferTickets}
            />
          ]}
          autoScrollBodyContent={true}
          onRequestClose={this._handleCloseModal}
        >
          {TicketStore.getState().isTransferring ? (
            <div>
              <CircularProgress
                mode="indeterminate"
                size={119}
                thickness={7}
                style={{ display: "block", margin: "10px auto 0" }}
              />
            </div>
          ) : this.state.promptForTransferEmail ? (
            <div>
              <p>
                Please enter the email address of the recipient who will receive
                your {this.state.selectedToTransfer.length} ticket
                {this.state.selectedToTransfer.length === 1 ? "" : "s"} to{" "}
                {event.name}. Until they accept the transfer, the ticket
                {this.state.selectedToTransfer.length === 1 ? "" : "s"} will
                remain in your account. Once they accept, the ticket
                {this.state.selectedToTransfer.length === 1 ? "" : "s"} will
                permanently disappear from your account unless the recipient
                transfers{" "}
                {this.state.selectedToTransfer.length === 1 ? "it" : "them"}{" "}
                back to you.
              </p>
              <TextField
                type="email"
                autoFocus={true}
                floatingLabelText="Recipient email address"
                floatingLabelFixed={true}
                value={this.state.transferEmail}
                onChange={e => this.setState({ transferEmail: e.target.value })}
              />
            </div>
          ) : (
            <div>
              <InjectedTenantHTML
                content={
                  this.context.tenant.physical_ticket_transfer_dialog_message
                }
              />
              {numberOfPendingTransfers > 0 ? (
                <div>
                  <p>
                    You currently have {numberOfPendingTransfers} pending
                    transfer{numberOfPendingTransfers === 1 ? "" : "s"}.
                  </p>
                  {Object.values(pendingTransfers).map(tickets => {
                    return (
                      <div style={styles.cancelTicketsItem}>
                        <TransferOrCancelDialogButtonWrapper>
                          <RaisedButton
                            style={Object.assign({}, styles.dialogButton, {
                              marginRight: 10
                            })}
                            label="Resend email"
                            onClick={() =>
                              this._handleResendTransfer(
                                tickets[0].pending_transfer.id
                              )
                            }
                          />
                          <RaisedButton
                            style={styles.dialogButton}
                            label="Cancel"
                            onClick={() =>
                              this._handleCancelTransfer(
                                tickets[0].pending_transfer.id
                              )
                            }
                          />
                        </TransferOrCancelDialogButtonWrapper>
                        <div>
                          {tickets.length} ticket
                          {tickets.length === 1 ? "" : "s"} to {event.name}
                        </div>
                        <div style={styles.cancelTicketsSub}>
                          Pending transfer to{" "}
                          {tickets[0].pending_transfer.to_email}
                        </div>
                      </div>
                    );
                  })}
                </div>
              ) : null}
              {transferableTickets.length === 0 ? (
                <p>
                  {numberOfPendingTransfers > 0
                    ? "You have no more tickets to this event eligible for transfer."
                    : "You currently have no tickets to this event eligible for transfer."}
                </p>
              ) : (
                <div>
                  <p>
                    {numberOfPendingTransfers > 0
                      ? `To begin another transfer, select`
                      : "Select"}{" "}
                    the tickets you would like to transfer, then click
                    "Transfer" in the lower righthand corner.
                  </p>
                  <Table
                    selectable={true}
                    multiSelectable={true}
                    onRowSelection={rows => {
                      this.setState({
                        selectedToTransfer: rows.map(
                          i => transferableTickets[i].id
                        )
                      });
                    }}
                    wrapperStyle={{ overflow: "auto"}}
                    style={{ overflow: "auto" }}
                    bodyStyle={{ overflow: "auto" }}
                  >
                    <TableBody
                      displayRowCheckbox={true}
                      showRowHover={false}
                      stripedRows={false}
                      deselectOnClickaway={false}
                    >
                      {transferableTickets.map(t => (
                        <TableRow
                          key={t.id}
                          style={{ cursor: "pointer" }}
                          selected={
                            this.state.selectedToTransfer.indexOf(t.id) !== -1
                          }
                        >
                          <TableRowColumn
                            style={{ paddingLeft: 0, fontSize: "11pt", overflow: "none" }}
                          >
                            {t.ticket_bucket.name}
                            {event.name ? ` · ${event.name}` : ""}
                            {t.seat ? ` · ${t.seat}` : ""}
                            {t.pass ? ` · ${t.pass.name}` : ""} · Ordered{" "}
                            {moment(t.created_at).format("lll")}
                          </TableRowColumn>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </div>
              )}
            </div>
          )}
        </Dialog>

        {this.props.buttonOnly ? (
          this._makeRightIcon({
            standalone: true
          })
        ) : (
          <ListItem
            secondaryText={
              <div style={{ display: "inline-block", overflow: "visible" }}>
                <div
                  style={{
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                  }}
                >
                  {event.is_virtual
                    ? `Virtual Screening`
                    : event.is_dated
                    ? `${timeRange}`
                    : null
                  }
                </div>
                {!event.is_virtual ? (
                  <div
                    style={{
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      width: "95%"
                    }}
                  >
                    {get(
                      event,
                      "venue.name",
                      "An Undisclosed Location"
                    )}
                  </div>
                ) : null}
                <div
                  style={{
                    overflow: "hidden",
                    whiteSpace: "nowrap"
                  }}
                >
                  {<div style={{ display: "flex", flexDirection: "column" }}>
                    {ticketBucketAmounts.map(bucket => <text key={bucket.name}>{`${bucket.amount} "${bucket.name}" ticket${bucket.amount === 1 ? "" :  "s"}`}</text>)}
                  </div>}
                  {numberOfPendingTransfers
                    ? ` · ${numberOfPendingTransfers} transfer${
                        numberOfPendingTransfers === 1 ? "" : "s"
                      } pending`
                    : null}
                  {passesUsed.length ? ` · ${passesUsed.join(", ")}` : null}
                  {passesUsed.length && passesUsed.length < tickets.length
                    ? ` + ${tickets.length - passesUsed.length} standalone`
                    : null}
                </div>
                {!this.props.hideActions && isCompactMultiRowButtons ? (
                    <div style={{ display: "inline-block", paddingTop: 4, paddingBottom: 25 }}>
                      {this._makeRightIcon({ isCompactMultiRowButtons, })}
                    </div>
                  ) : null}
              </div>
            }
            secondaryTextLines={3}
            rightIconButton={
              this.props.hideActions
                ? null
                : !isCompactMultiRowButtons
                ? this._makeRightIcon({ isCompactMultiRowButtons })
                : null
            }
            disabled={true}
            style={Object.assign(
              this.props.hideActions || isLarge
                ? styles.listItemLarge
                : styles.listItem,
              this.props.showBottomBorder && {
                borderBottom: "1px solid rgb(204,204,204)",
                paddingBottom: 36
              }/*,
              {
                height: !isCompactMultiRowButtons
                  ? "auto"
                  : showVote && hasLongVenue
                  ? 180
                  : showVote && !hasLongVenue
                  ? 163
                  : !showVote && hasLongVenue
                  ? 113
                  : 100
              }*/
            )}
            primaryText={<div style={{ width: isLarge ? "50%" : null }}>{event.name}</div>}
          />
        )}
      </div>
    );
  }
}

export default TicketListItem;



// WEBPACK FOOTER //
// ./src/app/components/partials/ticket-list/ticket-list-item.jsx